/* eslint no-unused-vars:0 */

import axios from "axios";
import {incomePlanAxios} from '../../axios';
import dayjs from "dayjs";
import Individual from "@/store/models/household/Individual";
const INDIVIDUAL_UPDATED = 'INDIVIDUAL_UPDATED';
export const individuals = {
    namespaced: true,
    state: {
        individuals: [],
        individualsDropdown: [],
        defaultPersonTwo: {
            id: null,
            name: '',
            birth_date: '',
            current_age: 18,
            retirement_age: 0,
            profession: null,
            role: 'person_two',
            le_strategy: 'ssa_female',
            will_die_at: 80,
        },
    },
    actions: {
        loadIndividuals ({ commit, getters, rootGetters }) {
            return axios
                .get('/api/household/' + rootGetters['auth/user'].household_id + '/individuals')
                .then(response => {
                    commit('setIndividuals', response.data.data.individuals);
                    return response;
                })
        },

        saveIndividual({ commit, state, getters, rootGetters }, {individualIndex, payload}) {
            return incomePlanAxios
                .put('/api/household/' + rootGetters['auth/user'].household_id + '/individuals/' + state.individuals[individualIndex].id, payload)
                .then(() => {
                    commit(INDIVIDUAL_UPDATED, {individualIndex, payload});
                })
        },

        saveIndividuals({ commit, getters, rootGetters }) {
            // Save first individual
            let personOne = getters.personOne;
            personOne.birth_date = dayjs(personOne.birth_date).format('MM/DD/YYYY');
            return axios.put('/api/household/' + rootGetters['auth/user'].household_id + '/individuals/' + personOne.id, personOne)
                .then(response => {
                    let person = response.data.data.individual;
                    person.birth_date = person.birth_date.substring(0, 10);
                    delete person.household;
                    delete person.income_streams;
                    delete person.other_incomes;
                    commit('setPersonOne', person);

                    // Save second individual
                    if (getters.personTwoExists) {
                        let personTwo = getters.personTwo;
                        personTwo.birth_date = dayjs(personTwo.birth_date).format('MM/DD/YYYY');
                        if (getters.personTwo.id === null) {
                            return axios.post('/api/household/' + rootGetters['auth/user'].household_id + '/individuals', personTwo)
                                .then(response => {
                                    let person = response.data.data.individual;
                                    person.birth_date = person.birth_date.substring(0, 10);
                                    delete person.household;
                                    delete person.income_streams;
                                    delete person.other_incomes;
                                    commit('setPersonTwo', person);
                                });
                        } else {
                            return axios.put('/api/household/' + rootGetters['auth/user'].household_id + '/individuals/' + personTwo.id, personTwo)
                                .then(response => {
                                    let person = response.data.data.individual;
                                    person.birth_date = person.birth_date.substring(0, 10);
                                    delete person.household;
                                    delete person.income_streams;
                                    delete person.other_incomes;
                                    commit('setPersonTwo', person);
                            });
                        }
                    }
                });
        },

        deleteIndividual({ commit, getters, rootGetters }, { individual, index }) {
            if (individual.id === null) {
                return commit('deleteIndividual', { individual, index });
            }

            return axios
                .delete('/api/household/' + rootGetters['auth/user'].household_id + '/individuals/' + individual.id)
                .then(response => {
                    commit('deleteIndividual', { individual, index });
                    return response;
                })
        },

        loadIndividualsDropdown ({ commit, getters, rootGetters }) {
            return axios
                .get('/api/household/' + rootGetters['auth/user'].household_id + '/individuals/dropdown')
                .then(response => {
                    commit('setIndividualsDropdown', response.data.data.individualsDropdown);
                    return response;
                })
        },
    },

    mutations: {
        [INDIVIDUAL_UPDATED] (state, {individualIndex, payload}) {
            for (let field in payload) {
                state.individuals[individualIndex][field] = payload[field];
            }
        },

        addRemovePersonTwo (state, isMarried) {
            if (isMarried && state.individuals.length === 1) {
                state.individuals.push({...state.defaultPersonTwo})
            }
            if (!isMarried && state.individuals.length === 2) {
                state.individuals.splice(1);
            }
        },
        setPersonOneIsWorking (state, isWorking) {
            if (isWorking) {
                state.individuals[0].retirement_age = 0;
            } else {
                state.individuals[0].retirement_age = state.individuals[0].current_age;
            }
        },
        setPersonTwoIsWorking (state, isWorking) {
            if (isWorking) {
                state.individuals[1].retirement_age = 0;
            } else {
                state.individuals[1].retirement_age = state.individuals[1].current_age;
            }
        },
        setPersonOneName (state, name) {
            state.individuals[0].name = name;
        },
        setPersonTwoName (state, name) {
            state.individuals[1].name = name;
        },
        setPersonOne (state, person) {
            state.individuals.splice(0, 1, person);
        },
        setPersonTwo (state, person) {
            state.individuals.splice(1, 1, person);
        },
        setPersonOneAge (state, age) {
            state.individuals[0].current_age = age;
        },
        setPersonTwoAge (state, age) {
            state.individuals[1].current_age = age;
        },
        setPersonOneRetirementAge (state, age) {
            state.individuals[0].retirement_age = age;
        },
        setPersonTwoRetirementAge (state, age) {
            state.individuals[1].retirement_age = age;
        },
        setIndividuals (state, individuals) {
            Individual.create({data: individuals});
            state.individuals = individuals;
        },
        setIndividualsDropdown (state, individualsDropdown) {
            state.individualsDropdown = individualsDropdown;
        },
        deleteIndividual(state, { individual, index }) {
            if (individual.id === null) {
                state.individuals.splice(index);
            } else {
                state.individuals = state.individuals.filter(i => i.id !== individual.id);
            }
        },
    },
    getters: {
        personOne(state) {
            return state.individuals[0];
        },
        personTwo(state) {
            if (state.individuals.length <= 1) {
                return null;
            }
            return state.individuals[1];
        },
        personTwoExists(state, getters) {
            return getters.personTwo !== null
        },
        personOneIsWorking(state) {
            return state.individuals[0].retirement_age === 0;
        },
        personTwoIsWorking(state) {
            if (state.individuals.length <= 1) {
                return false;
            }
            return state.individuals[1].retirement_age === 0;
        },
    }
};
